export class RoleConstants {

    public static readonly ADMIN:                      string = 'admin';
    public static readonly CONTRIBUTOR:                string = 'contributor';
    public static readonly READER:                     string = 'reader';
}          